<template>
    <div>
        <button
            class="btn btn-outline-dark"
            @click="emailChange = !emailChange"
        >Change Student Email</button>
        <br />
        <div v-if="emailChange">
            <br />
            <b>Changing student email will only change data in classes they are part of. Emails in assignments, reports, reportReceipts, feedbacks, and fcmTokens remain unchanged.</b>

            <v-text-field
                class="mt-3"
                label="Old Email"
                v-model.trim="oldEmail"
                :error-messages="emailErr"
            ></v-text-field>
            <v-text-field label="New Email" :rules="[email]" v-model.trim="newEmail"></v-text-field>
            <button
                :disabled="!checkComplete || !valid"
                class="btn btn-sm btn-outline-success mt-3"
                @click="changeEmail(); emailChange=false"
            >Submit</button>
        </div>
    </div>
</template>

<script>
import { debounce } from "lodash";
const fb = require("../../firebaseConfig");
const updateUserEmail = fb.functions.httpsCallable("updateUserEmail");

export default {
    data() {
        return {
            emailChange: false,
            oldEmail: "",
            newEmail: "",
            emailErr: "",
            checkComplete: false,
            valid: false,
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (pattern.test(value)) {
                    this.valid = true
                } else {
                    this.valid = false
                }
                return pattern.test(value) || "Invalid e-mail";
            }
        };
    },
    watch: {
        // whenever question changes, this function will run
        oldEmail: function(newVal, oldVal) {
            this.checkComplete = false;
            this.emailErr = "";
            if (!newVal) {
                return
            }
            this.debouncedChange();
        }
    },
    created() {
        this.debouncedChange = debounce(this.change, 2000);
    },
    methods: {
        change() {
            if (!this.oldEmail) {
                return
            }
            fb.db
                .collection("users")
                .where("type", "==", "student")
                .where("email", "==", this.oldEmail.toLowerCase())
                .get()
                .then(qs => {
                    if (qs.empty) {
                        this.emailErr = "No student found";
                    } else {
                        this.checkComplete = true;
                    }
                });
        },
        changeEmail() {
            updateUserEmail({
                email: this.oldEmail.toLowerCase(),
                newEmail: this.newEmail.toLowerCase()
            }).then(res => {
                console.log(res.data);
                this.$emit(
                    "toast",
                    "war",
                    "Process complete. Check logs in developer console."
                );
            });
            this.oldEmail = "";
            this.newEmail = "";
        }
    }
};
</script>